module.exports = __webpack_public_path__ + "media/aoka_cloud.0b177970.mp4";